import React from "react";

export default function SidebarCollapseIcon({ className, size = 14, strokeWidth = 1.5, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M3.75.75h-.6c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656C.75 1.889.75 2.31.75 3.15v7.2c0 .84 0 1.26.163 1.58a1.5 1.5 0 0 0 .656.657c.32.163.74.163 1.579.163h.602m0-12h6.6c.84 0 1.26 0 1.58.163a1.5 1.5 0 0 1 .657.656c.163.32.163.74.163 1.579v7.205c0 .838 0 1.257-.163 1.578a1.5 1.5 0 0 1-.656.656c-.321.163-.74.163-1.579.163H3.75m0-12v12" />
    </svg>
  );
}
